$(document).ready(function(){
  $(".chart-donut span").peity("donut");
});